import {secured as axios} from "../../../axios"

class InstitutionQuery {
    static url = '/institutions'

    static mapInstitutionData(institution) {
        // Map the institution data as per your requirements
        return institution;
    }

    static async getInstitutionsByCommunity(communityId) {
        return await axios.get(`community/${communityId}/institution`)
            .then(res => {
                return res.data.map(this.mapInstitutionData)
            })
    }
}

export { InstitutionQuery };
